import { Controller } from "@hotwired/stimulus";
import { makeMatcher } from "../utils/text_match";
import Sortable from "sortablejs";

// Per-resource list of custom field definitions :
//   - drag-drop reorder via Sortable, persisted via fetch on the `move` route
//   - live filter by name or internal_name
export default class extends Controller {
  static targets = ["items", "item", "search", "handle"];
  static values  = {
    moveUrlTemplate: String,  // ".../custom_field_definitions/PLACEHOLDER/move"
    resourceType:    String,
    token:           String,
  };

  connect() {
    if (this.hasItemsTarget) {
      this._sortable = Sortable.create(this.itemsTarget, {
        animation: 150,
        handle: ".cf-card__handle",
        ghostClass: "cf-card--ghost",
        onEnd: (event) => this._onReorder(event),
      });
    }
  }

  disconnect() {
    if (this._sortable) this._sortable.destroy();
  }

  filter() {
    const matcher = makeMatcher(this.searchTarget.value);
    this.itemTargets.forEach((row) => {
      const name = row.dataset.cfName || "";
      const iname = row.dataset.cfInternalName || "";
      const match = matcher(`${name} ${iname}`);
      row.hidden = !match;
    });
  }

  async _onReorder(event) {
    const item = event.item;
    if (!item) return;
    const newPosition = event.newIndex + 1;
    const cfId = item.dataset.cfId;
    if (!cfId) return;

    const url = this.moveUrlTemplateValue.replace("PLACEHOLDER", cfId);
    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.tokenValue,
          "Accept": "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({
          position: newPosition,
          resource_type: this.resourceTypeValue,
        }),
      });
      if (!response.ok) {
        console.error("Failed to reorder field", await response.text());
      }
    } catch (e) {
      console.error("Network error while reordering field", e);
    }
  }
}
